import { render, staticRenderFns } from "./ComplexItem.vue?vue&type=template&id=1a293e9e&scoped=true&"
import script from "./ComplexItem.vue?vue&type=script&lang=js&"
export * from "./ComplexItem.vue?vue&type=script&lang=js&"
import style0 from "./ComplexItem.vue?vue&type=style&index=0&id=1a293e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a293e9e",
  null
  
)

export default component.exports